// extracted by mini-css-extract-plugin
export var deliveryRow = "_pn-a";
export var fixedHeight = "_pn-4";
export var freightLogo = "_pn-9";
export var fullWidth = "_pn-3";
export var priceColumn = "_pn-5";
export var radioSelected = "_pn-7";
export var radioUnselected = "_pn-6";
export var selectedOption = "_pn-2";
export var selectedOptionContainer = "_pn-1";
export var selection = "_pn-0";
export var tallSkeletonText = "_pn-8";